/* eslint-disable spire/export-styles */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import React, { useState, useEffect } from 'react';
import { connect, ResolveThunks } from "react-redux";
import Modal from "@insite/mobius/Modal";
import siteMessage from "@insite/client-framework/SiteMessage";
import { CartResult, GetCartApiParameter, getCart } from "@insite/client-framework/Services/CartService";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
type OwnProps =
    | {
        variant: "primary" | "secondary" | "tertiary";
        buttonDisabled: boolean | undefined;
        extendedStyles?: ButtonPresentationProps;
    };

const mapDispatchToProps = {

};

const mapStateToProps = (state: ApplicationState) => {
    const cartState = getCurrentCartState(state);
    const { isSavingOrder } = state.pages.cart;
    const { isUpdatingCart } = state.context;
    return {
        isDisabled:
            cartState.isLoading ||
            isSavingOrder ||
            isUpdatingCart ||
            cartState.value?.lineCount === 0 ||
            cartState.value?.cartLines?.length === 0,
        isSignedIn: cartState.value?.isAuthenticated && !cartState.value?.isGuestOrder        
    };
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    HasHistory &
    HasToasterContext &
    ResolveThunks<typeof mapDispatchToProps>;

export const QuoteButton = ({
    isDisabled,
    extendedStyles,
    isSignedIn,
    variant,
    buttonDisabled
}: Props) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [data, setData] = useState<CartResult>();
    const [aspenIframeCartLine, setAspenIframeCartLine] = useState<string>("");
    useEffect(() => {
        const fetchCartdata = async () => {
            try {
                const cartResult = await getCart({
                    cartId: API_URL_CURRENT_FRAGMENT,
                    expand: ["cartLines"],
                } as GetCartApiParameter);
                setData(cartResult);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        if (modalIsOpen) {
            fetchCartdata();
        }
    }, [modalIsOpen]);

    useEffect(() => {
        const assignCartdata = () => {
            try {
                var cartLines = data?.cart?.cartLines;
                if (cartLines) {

                    setAspenIframeCartLine(cartLines.map(cartLineItem => {
                        return cartLineItem.erpNumber + "(" + cartLineItem.qtyOrdered + ")";

                    }).join(','));
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        assignCartdata();
        const interval = setInterval(() => {
            const iframes: HTMLCollectionOf<HTMLIFrameElement> = document.getElementsByTagName('iframe');
            if (iframes) {
                clearInterval(interval);
                setCartineValue(iframes[0]);
            }
        }, 300);

    }, [data]);


    useEffect(() => {

        const interval = setInterval(() => {
            const iframes: HTMLCollectionOf<HTMLIFrameElement> = document.getElementsByTagName('iframe');
            if (iframes) {
                clearInterval(interval);
                setCartineValue(iframes[0]);

            }
        }, 300);

    }, [aspenIframeCartLine]);

    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };

    const modalContent = () => {
        return (
            <div>

                {siteMessage("RequestQuote_PopUpContent")}

            </div>
        );
    };
    const handleClick = () => {
        if (!isSignedIn) {
            setModalIsOpen(true);
            return;
        }
        else {
            window.location.href = "/WebQuote";
        }
    };

    const setCartineValue = (iframe: any) => {
        const url = new URL(iframe.src);
        url.searchParams.set('Product_s_Interest', aspenIframeCartLine);
        iframe.src = url.toString();
    }

    return (
        <>

            <Modal isOpen={modalIsOpen} handleClose={modalCloseHandler}>
                {" "}
                {modalContent()}{" "}
            </Modal>

            <Button variant={variant}
                disabled={!isSignedIn ? false : (isDisabled || buttonDisabled)}
                data-test-selector="quote_request_create"
                {...extendedStyles}
                onClick={handleClick}
            >
                {!isSignedIn ? translate("Request a Quote") : translate("Generate a Quote")}
            </Button>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(withToaster(QuoteButton)));


